import Home from '../Home/index'
import ContactForm from '../ContactForm/index'
import { Switch, Route } from 'react-router-dom'
import React from 'react'
import ProductPage from '../ProductPage/ProductPage'
import green1 from '../../media/projectImages/greeni-1.jpg'
import green2 from '../../media/projectImages/greeni-2.jpg'
import green3 from '../../media/projectImages/greeni-3.jpg'
import green4 from '../../media/projectImages/greeni-4.jpg'

const artificialGreenImages = [green1, green2, green3, green4]

class App extends React.Component {
  componentDidMount () {
    document.querySelectorAll('a[href^="#"]').forEach(anchor => {
      anchor.addEventListener('click', function (e) {
        e.preventDefault()

        document.querySelector(this.getAttribute('href')).scrollIntoView({
          behavior: 'smooth'
        })
      })
    })
  }

  render () {
    return (
      <main role='main'>
        <Switch>
          <Route path='/' component={Home} exact />
          <Route path='/about' component={ContactForm} />
          <Route path='/artificial' component={() => <ProductPage projectImages={artificialGreenImages} />} />
        </Switch>
      </main>
    )
  }
}

export default App
